import React from 'react'
import ProductImage from './index'

export const HaulerNextProductImage = () => {
  return <ProductImage imageSource="/assets/img/app-logo/hauler-next.png" color="#1ab394" />
}
